import React, { useState } from 'react';
import ResendInviteModal from './ResendInviteModal';

/* Accounts somebody else created, and so have an invite to resend. */
const ADMIN_CREATED_SOURCES = ['admin_import', 'partner_import'];

/**
 * Whether this talent is still waiting on the invite an admin sent them.
 *
 * Two conditions, and both matter. A talent who signed themselves up chose
 * their own password and never had an invite. And `invite_pending` - an
 * unspent set-password token - is what says the invite has not been acted
 * on yet; it is cleared the moment they choose a password, so it is a
 * sharper signal than a half-filled profile. Someone who has set a password
 * but not finished their profile needs a nudge to finish it, which is a
 * different email from "your account is ready".
 */
export function awaitingInvite(talent) {
  if (!talent) {
    return false;
  }

  const madeByAnAdmin = ADMIN_CREATED_SOURCES.indexOf(talent.registration_source) !== -1;

  if (!madeByAnAdmin) {
    return false;
  }
  return talent.invite_pending === true;
}

/**
 * Opens the resend form for one talent.
 *
 * The form rather than a straight resend, because a second attempt usually
 * wants a different pitch - the first one went unanswered.
 */
const ResendInviteButton = ({ talent }) => {
  const [open, setOpen] = useState(false);

  /* Nothing for the people who signed themselves up, or who have already
     used their invite - which is most of the list. */
  if (!awaitingInvite(talent)) {
    return null;
  }

  return (
    <>
      <button
        type='button'
        onClick={() => setOpen(true)}
        className='text-sm inline-block rounded-lg border border-border py-[1.56px] px-[11.7px] text-muted-foreground hover:text-foreground'
        title='Send the set-password invite again'
      >
        Resend invite
      </button>

      <ResendInviteModal open={open} talent={talent} onClose={() => setOpen(false)} />
    </>
  );
};

export default ResendInviteButton;
